const firebaseConfig = {
  apiKey: 'AIzaSyCspfo7fWAzPJCGqZuPkRlD2wAiRy73X9k',
  authDomain: 'restohub-app.firebaseapp.com',
  projectId: 'restohub-app',
  storageBucket: 'restohub-app.appspot.com',
  messagingSenderId: '898764726724',
  appId: '1:898764726724:web:f4f7895a12d7b837438491',
  measurementId: 'G-STXEJ1ZXHG',
};

export default firebaseConfig;
